











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaKarcher} from '@/model/resource/CargaKarcher'
import {CargaKarcherCollection} from '@/model/collection/CargaKarcherCollection'
import {ListCargaKarcherSchema} from '@/schema/resource/CargaKarcher/ListCargaKarcherSchema'
import {CsvCargaKarcherSchema} from '@/schema/resource/CargaKarcher/CsvCargaKarcherSchema'

@Component
export default class ListCargaKarcherView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaKarcherSchema()
  collection = new CargaKarcherCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaKarcher) {
    Helper.pushByName('editCargaKarcher', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaKarcherCollection().clearFilters().addFilter(params)

    await csv.listCsvCargaKarcher()
    new CsvCargaKarcherSchema().downloadCsv(csv.all())
  }
}
